import { application } from "./application"

// Device + editor controllers (the lesson player and synth lab are Leptos
// islands now — player/ crate — with no Stimulus controllers; all audio
// lives in the Rust crates).
import MidiController from "./midi_controller"
import UsbController from "./usb_controller"
import LessonEditorController from "./lesson_editor_controller"
import TimingEditorController from "./timing_editor_controller"

// UI controllers
import FlashController from "./flash_controller"
import ModalController from "./modal_controller"
import DropdownController from "./dropdown_controller"
import ThemeController from "./theme_controller"
import BpmController from "./bpm_controller"

application.register("midi", MidiController)
application.register("usb", UsbController)
application.register("lesson-editor", LessonEditorController)
application.register("timing-editor", TimingEditorController)
application.register("flash", FlashController)
application.register("modal", ModalController)
application.register("dropdown", DropdownController)
application.register("theme", ThemeController)
application.register("bpm", BpmController)
